import { render, staticRenderFns } from "./CompletedFilters.vue?vue&type=template&id=3643c15e&scoped=true&"
import script from "./CompletedFilters.vue?vue&type=script&lang=js&"
export * from "./CompletedFilters.vue?vue&type=script&lang=js&"
import style0 from "./CompletedFilters.vue?vue&type=style&index=0&id=3643c15e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3643c15e",
  null
  
)

export default component.exports